<script lang="ts" setup>
import type { User } from 'types';
import Navigation, { type Breadcrumb } from './Navigation.vue';

defineProps<{
    authUser: User;
    breadcrumbs?: Breadcrumb[];
    canViewAny?: Record<string, boolean>;
    canView?: Record<string, boolean>;
}>();
</script>

<template>
    <Navigation
        :auth-user="authUser"
        :breadcrumbs="breadcrumbs"
        :can-view-any="canViewAny"
        :can-view="canView">
        <slot />
    </Navigation>
</template>